import http from '../axios.ts'


const api = {
    /**
     * 发送邮箱验证码
     * @param params  $toEmail：收件箱地址，$type：login、register、seekpwd、updatePwd
     */
    getAll(params:Object) {
        const res = http.post('/sku/getAll', params);
        return res;
    },

    /**
     * 获取所有SKU 列表
     */
    getAllByGoodsId(params:Object) {
        const res = http.post('/sku/getAllByGoodsId', params);
        return res;
    },

    /**
     * 获取所有SKU 列表
     */
    getVipSslAll(params:Object) {
        const res = http.post('/sku/getVipSslAll', params);
        return res;
    },

    /**
     * 修改VIP SKU 价格
     */
    vipSkuPriceSave(params:Object) {
        const res = http.post('/sku/vipSkuPriceSave', params);
        return res;
    },

    /**
     * 修改SKU 是否支持创建token
     */
    setIsTokenBySkuId(params:Object) {
        const res = http.post('/sku/setIsTokenBySkuId', params);
        return res;
    }
}

export default api
